import { render, staticRenderFns } from "./layer-batch-write-off.vue?vue&type=template&id=a28f9fb2&scoped=true&"
import script from "./layer-batch-write-off.vue?vue&type=script&lang=js&"
export * from "./layer-batch-write-off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28f9fb2",
  null
  
)

export default component.exports